import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getOrEmptyObject, getStringArrayProp, values } from '@mews/fp';
import { getEntities } from '../getEntities';

const getRestrictions = createSelector(getEntities, get('restrictions'));

export const getRestrictionsData = createSelector(getRestrictions, getOrEmptyObject('data'));

const getRestrictionsArray = createSelector(getRestrictionsData, (restrictionData) => values(restrictionData));

export const getSomeRestrictions = createSelector(
    getRestrictionsArray,
    getStringArrayProp('restrictionIds'),
    (restrictions, restrictionIds) =>
        pipe(
            restrictions,
            array.filter(({ id }) => restrictionIds.includes(id))
        )
);
